import stringify from "qs/lib/stringify"
import dayjs from 'dayjs';

export const productSelect2 = function (select, data) {
    select.select2({
        data: data,
        theme: "bootstrap",
        placeholder: "请选择产品",
        language: "zh-CN",
        allowClear: true,
    });
};

export const queryStringify = (params) => stringify(params, { arrayFormat: 'brackets' })


export const formatDate = (dateString) => {
    const date = dayjs(dateString);
    // Then specify how you want your dates to be formatted
    return date.format('YYYY-MM-DD HH:mm');
}

export const getCurrentRoles = () => Array.isArray(window.roles) ? window.roles : []

export const hasRoles = (roles = [], currentRoles = getCurrentRoles()) => {
    if (!Array.isArray(roles) || roles.length === 0) return false
    return roles.some((role) => currentRoles.includes(role))
}

export const genUniqId = () => Math.floor(Math.random() * Date.now()).toString(16)

// Only recurse into plain objects. Non-plain objects (File, Blob, Date,
// FormData, Map, ...) are returned as-is -- recursing into them via
// Object.entries would destroy them (e.g. a File's name/size/type are
// non-enumerable accessors, so Object.entries(file) === []), which silently
// drops uploads and breaks Inertia's multipart detection.
const isPlainObject = (v) => {
  if (v === null || typeof v !== "object") return false;
  const proto = Object.getPrototypeOf(v);
  return proto === null || proto === Object.prototype;
};

export const stripDisplayFields = (obj) => {
  if (Array.isArray(obj)) return obj.map(stripDisplayFields);
  if (!isPlainObject(obj)) return obj;
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([key]) => key === "_destroy" || !key.startsWith("_"))
      .map(([key, val]) => [key, stripDisplayFields(val)])
  );
}
